import styled from 'styled-components';
import { Icon } from '../../../../components/common/icon/Icon';
import { MachineType } from '../../../../interfaces/Brand.interfaces';

interface ProductSpecSummarySectionProps {
  manufacturedYear: number;
  operationTime: number;
  engineOutputInPs: number;
  isGrayscale?: boolean;
  machineType: MachineType;
  rowConfig: string;
}

export const ProductSpecSummarySection = ({
  manufacturedYear,
  operationTime,
  engineOutputInPs,
  isGrayscale = false,
  machineType,
  rowConfig,
}: ProductSpecSummarySectionProps) => {
  const iconStyle = isGrayscale ? { filter: 'grayscale(100%)' } : {};
  return (
    <ProductSpecSummary>
      <ProductSpecWrapper>
        <Icon name={'PDPYearLight2'} width={48} height={48} style={iconStyle} />
        <ProductSpecTitleAndDescription>
          <ProductSpecTitle>{'연식'}</ProductSpecTitle>
          <ProductSpecDescription>{`${manufacturedYear}년식`}</ProductSpecDescription>
        </ProductSpecTitleAndDescription>
      </ProductSpecWrapper>
      <ProductSpecWrapper>
        <Icon name={'PDPTimeLight2'} width={48} height={48} style={iconStyle} />
        <ProductSpecTitleAndDescription>
          <ProductSpecTitle>{'사용시간'}</ProductSpecTitle>
          <ProductSpecDescription>{`${operationTime.toLocaleString()}시간`}</ProductSpecDescription>
        </ProductSpecTitleAndDescription>
      </ProductSpecWrapper>
      <ProductSpecWrapper>
        <Icon
          name={machineType === 'combine' || machineType === 'transplanter' ? 'PDPRowLight2' : 'PDPPSLight2'}
          width={48}
          height={48}
          style={iconStyle}
        />
        <ProductSpecTitleAndDescription>
          <ProductSpecTitle>
            {machineType === 'combine' || machineType === 'transplanter' ? '조식' : '마력'}
          </ProductSpecTitle>
          <ProductSpecDescription>
            {machineType === 'combine' || machineType === 'transplanter' ? rowConfig : `${engineOutputInPs}마력`}
          </ProductSpecDescription>
        </ProductSpecTitleAndDescription>
      </ProductSpecWrapper>
    </ProductSpecSummary>
  );
};

const ProductSpecSummary = styled.div`
  display: flex;
  align-items: flex-start;
  align-self: stretch;
`;

const ProductSpecWrapper = styled.div`
  display: flex;
  padding: 0px var(--radius-large, 16px);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-medium, 8px);
  flex: 1 0 0;
`;

const ProductSpecTitleAndDescription = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--radius-medium, 8px);
`;

const ProductSpecTitle = styled.span`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);

  /* System/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 85%; /* 11.9px */
`;

const ProductSpecDescription = styled.span`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* System/Large/l-bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 85%; /* 13.6px */
`;
